import React, { useState } from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useAtlasV2MetricByWeekId } from 'src/serverProxy/useAtlasV2MetricByWeekId';
import DonutChartLoading from 'src/components/Charts/Donut/DonutChartLoading';
import CircularProgressPercentage from 'src/components/common/UploadAnimation/CircularProgressPercentage';
import BeaconChartWithLegend from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconChartWithLegend';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { formatMetric } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import { Grid } from '@mui/material';
import {
  DorisMetricEndPointEnum,
  DorisMetricTypeEnum
} from 'src/components/AtlasV2Components/Consts/DorisFieldNameEnum';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';

/**
 * Shows donut chart and spline charts for the top section Ratings
 */
export const AtlasRatingsV2TopSection = () => {
  // this is little hacky way, but we fetch data inside of the spline chart, and take only last value from there.
  const [lastPrimaryValue, setLastPrimaryValue] = useState<number | null>(1);
  const [splineChartLoading, setSplineChartLoading] = useState(true);

  return (
    <BeaconChartWithLegend title="Rating" showExportMenu={false}>
      <Grid display="grid" alignItems="center" justifyContent="space-between" gridTemplateColumns="308px 655px">
        <div style={{ width: '308px', height: '308px' }}>
          {splineChartLoading ? (
            <DonutChartLoading />
          ) : (
            <CircularProgressPercentage
              percentage={lastPrimaryValue / 5}
              customLabel={
                <Flex gap="sm" alignItems="center" flexDirection="column">
                  <Text
                    sx={{
                      fontSize: '48px',
                      fontWeight: 'bold'
                    }}
                  >
                    {`${formatMetric(lastPrimaryValue, METRICTYPE.DECIMAL, {
                      showFullValue: false,
                      decimalPlaces: 1
                    })}`}
                  </Text>
                  <Text
                    sx={{
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    Avg. Star Rating
                  </Text>
                </Flex>
              }
            />
          )}
        </div>
        <div style={{ flex: 1 }}>
          <AtlasV2DorisSplineChart
            queryKey="promotion-count-weekly"
            methodName={DorisMetricEndPointEnum.SalesEndPoint}
            metricTypeDisplay={METRICTYPE.DECIMAL}
            showLastWeekValue
            metricType={DorisMetricTypeEnum.ReviewsRating}
            showTitleSummary={false}
            beaconChartWithLegendOverride={(props, metric) => {
              const { lastPrimaryValue, isLoading } = metric;
              setLastPrimaryValue(lastPrimaryValue);
              setSplineChartLoading(isLoading);
              return {
                ...props,
                loadingComponent: <SplineChartLoading width={664} />
              };
            }}
            chartOptionsOverride={{
              chart: {
                height: 280,
                width: 664
              }
            }}
          />
        </div>
      </Grid>
    </BeaconChartWithLegend>
  );
};
